import { SERVER_URL } from './../config/contants';
import { HEADERS } from './../config/contants';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { JwtHelper, tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { LocalStorageProvider } from '../providers/local-storage';
import 'rxjs/add/operator/map';


interface DadosUsuario {
  id: number,
  nome: string
}

@Injectable()
export class Autenticacao {

  contentHeader: Headers = new Headers(HEADERS);

  jwtHelper: JwtHelper = new JwtHelper();

  public usuario: DadosUsuario = {
    id: null,
    nome: null
  }

  public token: string

  constructor(
    public http: Http,
    private authHttp: AuthHttp,
    public events: Events,
    public storage: Storage,
    private localStorage: LocalStorageProvider
  ) {

  }

  login(credentials) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'autenticacao/login', JSON.stringify(credentials), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
          data => {
            if (data.response == 'valid') {
              this.updateToken(data.token)
            }
            resolve(data)
          },
          err => {
            reject(err)
          }
        );
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      this.authHttp.get(SERVER_URL + 'autenticacao/remove', { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
          data => {
            this.storage.remove('usuario')
            this.storage.remove('token')
            this.storage.remove('sem_login')
            this.storage.remove('pontos')
            this.storage.remove('registros')
            this.events.publish('user:logout')
            resolve();
          }, err => {
            reject();
          }
        );
    });
  }

  refreshToken() {
    return new Promise((resolve, reject) => {
      this.authHttp.get(SERVER_URL + 'autenticacao/refresh', { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
          data => {
            if(data.response) {
              this.updateToken(data.token)
            }
            resolve(data)
          },
          err => {
            reject(err)
          }
        );
    });
  }

  checkCpf(cpfLong) {

    let body = {
      cpf: cpfLong.replace(/\D/g, '')
    }

    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'autenticacao/cpf', JSON.stringify(body), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
          data => {
            resolve(data)
          },
          err => {
            reject(err)
          }
        );
    });
  }

  public autenticado() {
    return tokenNotExpired(null, this.token)
  }

  public updateToken(token) {
    this.usuario.id     = this.jwtHelper.decodeToken(token).id
    this.usuario.nome   = this.jwtHelper.decodeToken(token).username
    
    this.localStorage.storageSave('usuario', this.usuario)

    this.events.publish('user:login')

    this.storage.set('sem_login', false)   
    this.storage.set('token', token)
  }

  getUserId() {
    return this.usuario.id
  }

  getUserName() {
    return this.usuario.nome
  }

  setSemLogin() {
    this.storage.set('sem_login', true)  
  }

  hasLoggedIn() {
    return new Promise((resolve, reject) => {
      this.localStorage.storageGet('token').then(
        data => {
          resolve(tokenNotExpired(null, data))
        }, erro => {
          reject(erro)
        }
      )
    })
  }

}


// WEBPACK FOOTER //
// ./src/providers/autenticacao.ts